import React, { useEffect } from 'react'
import { node } from 'prop-types'
import { useSelector } from 'react-redux'
import { useAuthenticationContext } from './AuthenticationContext'
import { selectors as coreSelectors } from 'mage-core'
import { CenteredContent, Loader, SpacerVertical } from 'mage-deps/@klarna/bubble-ui'

AuthenticationRequired.propTypes = { children: node }

function AuthenticationRequired ({ children }) {
  const isAuthenticated = useSelector(coreSelectors.isAuthenticated)

  const { setAuthenticationRequired, isAuthenticationRequired } = useAuthenticationContext()

  useEffect(() => {
    if (!isAuthenticationRequired) {
      setAuthenticationRequired(true)
    }
  }, [isAuthenticationRequired])

  return isAuthenticated
    ? children
    : (
      <>
        <SpacerVertical large />
        <CenteredContent illustration={<Loader />} />
      </>
    )
}

export default AuthenticationRequired
